// extracted by mini-css-extract-plugin
export default {"Chat":"Chat_Chat__NHq0p","question":"Chat_question__7VqA1","answer":"Chat_answer__P49-p"};